import { LocationState } from "~/constants";

type HandleNavigate = {
  stepData: { route: string; isExternal: boolean };
  navigate: (
    to: string,
    options?: { replace: boolean; state: LocationState | undefined },
  ) => void;
  isPrevious?: boolean;
  state?: LocationState;
  tracker: () => void | undefined;
};

export const handleNavigate = ({
  stepData,
  navigate,
  isPrevious,
  state,
  tracker,
}: HandleNavigate) => {
  tracker && tracker();

  if (stepData.isExternal) {
    window.location.href = stepData.route;
    return;
  }

  navigate(stepData.route, { replace: !!isPrevious, state });
};
